export { default as StyledCounter } from './StyledCounter';
